<template>
  <v-card flat class="vetalfa-card-grey-border pa-4">
    <p class="subtitle-2 font-weight-bold ma-0 mb-2">Dados profissionais</p>

    <v-text-field
      v-if="!readonly"
      v-model="localValue"
      :rules="rules"
      label="Número de cadastro no MAPA/SIPEAGRO (opcional)"
      placeholder="MV00000000000"
      maxlength="13"
      counter="13"
      outlined
      dense
      clearable
      hide-details="auto"
      @input="emitNormalized"
      @blur="normalizeLocalValue"
    ></v-text-field>
    <div v-else-if="normalizedValue" class="mb-2">
      <span class="caption grey--text text--darken-1">MAPA/SIPEAGRO</span>
      <p class="body-2 font-weight-medium ma-0">{{ normalizedValue }}</p>
    </div>

    <p class="caption grey--text text--darken-1 ma-0 mt-2">
      O cadastro no MAPA é diferente do número de notificação de receita. A
      informação não habilita emissão de receita controlada nem representa
      assinatura digital certificada.
    </p>
    <a
      :href="mapaLookupUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="caption d-inline-block mt-2"
    >
      Consultar médicos-veterinários cadastrados no SIPEAGRO
    </a>
  </v-card>
</template>

<script>
const MAPA_PATTERN = /^MV[0-9]{11}$/;

export default {
  name: "ProfessionalRegistrationFields",
  props: {
    value: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.normalize(this.value),
      mapaLookupUrl:
        "https://mapa-indicadores.agricultura.gov.br/publico/extensions/Medicos_veterinarios_cadastrados_no_sipeagro/Medicos_veterinarios_cadastrados_no_sipeagro.html",
      rules: [
        (value) =>
          !value ||
          MAPA_PATTERN.test(this.normalize(value)) ||
          "Informe MV seguido de 11 números.",
      ],
    };
  },
  computed: {
    normalizedValue() {
      return this.normalize(this.value);
    },
  },
  watch: {
    value(value) {
      const normalized = this.normalize(value);
      if (normalized !== this.localValue) this.localValue = normalized;
    },
  },
  methods: {
    normalize(value) {
      if (value === null || value === undefined) return "";
      return String(value).trim().toUpperCase();
    },
    emitNormalized(value) {
      const normalized = this.normalize(value);
      this.localValue = normalized;
      this.$emit("input", normalized || null);
    },
    normalizeLocalValue() {
      this.emitNormalized(this.localValue);
    },
  },
};
</script>
